import { render, staticRenderFns } from "./BuyBoxUpcomingWithNoOffers.vue?vue&type=template&id=1ddb67a9"
import script from "./BuyBoxUpcomingWithNoOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxUpcomingWithNoOffers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxUpcomingWithNoOffers.vue?vue&type=style&index=0&id=1ddb67a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports